import type { CheckboxShapeEnum } from '@lighthouse/core'

export const checkBoxShapeMap: Record<CheckboxShapeEnum, string[]> = {
    collect: ['OutlineStar', 'StartFill'],
    heart: ['OutlineHeart', 'HeartFill'],
    checkbox: ['', 'CheckboxTick'],
    flag: ['OutlineFlag', 'FlagFill'],
    like: ['OutlineLike', 'LikeFill']
}
